<template>
  <div style="min-height: 80vh" class="mx-5">
    <div
      style="position: sticky; top: 6vh; z-index: 1000"
      :class="{
        'bg-light': !isDarkMode,
        'bg-dark text-light ': isDarkMode
      }"
    >
      <h1
        :class="{
          'bg-light text-center page-title ': !isDarkMode,
          'bg-dark text-light text-center page-title ': isDarkMode
        }"
        class=""
        >{{ title }}</h1
      >
      <b-row
        style="justify-content: space-between"
        :class="{
          'bg-light mx-2  py-3': !isDarkMode,
          ' mx-2  py-3 bg-dark text-light': isDarkMode
        }"
      >
        <b-col xl="6">
          <b-row>
            <b-col>
              <b-form data-v-step="1">
                <b-input-group class="box-shadow2 mb-2">
                  <b-input-group-append>
                    <b-form-datepicker
                      sm
                      button-only
                      id="start-datepicker"
                      placeholder="Start Date"
                      :min="minDate"
                      :max="maxDate"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      v-model="startDateValue"
                    >
                    </b-form-datepicker>
                  </b-input-group-append>
                  <b-form-input
                    id="example-input"
                    v-model="startDateValue"
                    type="text"
                    placeholder="Start Date"
                    autocomplete="off"
                    :class="{
                      '': !isDarkMode,
                      'bg-dark text-light': isDarkMode
                    }"
                    disabled
                  ></b-form-input>
                </b-input-group> </b-form
            ></b-col>
            <b-col>
              <b-form>
                <b-input-group class="box-shadow2 mb-2">
                  <b-input-group-append>
                    <b-form-datepicker
                      button-only
                      id="end-datepicker"
                      placeholder="End Date"
                      :min="minDate"
                      :max="maxDate"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      v-model="endDateValue"
                    ></b-form-datepicker>
                  </b-input-group-append>
                  <b-form-input
                    id="example-input"
                    v-model="endDateValue"
                    type="text"
                    placeholder="End Date"
                    autocomplete="off"
                    :class="{
                      '': !isDarkMode,
                      'bg-dark text-light ': isDarkMode
                    }"
                    disabled
                  ></b-form-input>
                </b-input-group> </b-form
            ></b-col>
            <b-col>
              <b-form>
                <b-button
                  data-v-step="2"
                  :class="{
                    'box-shadow2 btn btn-success  mb-2': !isDarkMode,
                    'btn btn-primary text-light  mb-2': isDarkMode
                  }"
                  @click="showChart"
                  ><font-awesome-icon class="mr-1" :icon="['fas', 'arrow-alt-circle-right']"
                /></b-button> </b-form
            ></b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <!-- <b-overlay :show="loading" :variant="!isDarkMode ? 'light' : 'dark'" rounded="sm" no-wrap>
      <template #overlay>
        <div class="d-flex justify-content-center align-items-center h-100">
          <b-spinner :variant="!isDarkMode ? 'dark' : 'light'" label="Loading"></b-spinner>
        </div>
      </template>
</b-overlay> -->
    <b-row
      :class="{
        ' mt-4 mx-2': !isDarkMode,
        'mt-4 bg-dark text-light mx-2': isDarkMode
      }"
    >
      <b-col>
        <DashboardSectionASM
          :loading="this.aSMDashboardLoading"
          :chartVisible="chartVisible"
          :dashboardDetails="aiReportStatus"
          :checked="imageType === 'correct' ? true : false"
          :switchRequired="true"
          :showAdd="true"
          :aSMReportLoading="this.aSMReportLoading"
          addText="Download Report"
          @update-image-type="imageType = $event"
          @add="downloadASMReport"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import router from '@/router';
import { mapState, mapActions, mapGetters } from 'vuex';
import DashboardSectionASM from '../../components/DashboardSectionASM.vue';
import { LoggedInUser } from '../../helper/dashboard.js';
import _ from 'lodash';

export default {
  name: 'Dashboard2',
  metaInfo() {
    return {
      title: 'ASM Wise Dashboard',
      meta: [
        {
          name: 'description',
          content: `See Charts`
        }
      ]
    };
  },
  components: { DashboardSectionASM },
  data() {
    return {
      title: 'ASM Wise Dashboard',
      asmName: '',
      startDateValue: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      endDateValue: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      minDate: moment().subtract(3, 'month').format('YYYY-MM-DD'),
      maxDate: moment().format('YYYY-MM-DD'),
      chartVisible: true,
      imageType: 'correct',
      aiReportStatus: {
        heading: `AI correct status`,
        overallCompletion: 0,
        regionDetails: [],
        checklists: []
      }
    };
  },
  async mounted() {
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
      this.startDateValue = this.$route.query.startdate;
    }
    if (this.ifPettyCashTeam) {
      router.push('/petty-cash');
    } else {
      await this.getStoreByUser();
      this.listStore({ router });
      this.asmListAction({ router });
      this.listRegion({ router, query: { type: 'region' } });
      this.list({ type: 'user', query: this.$route.query });
      const abc = LoggedInUser(this.user, this.store);
      if (abc.userType !== 'RSM' && abc.userType !== 'ASM' && abc.userType !== 'SM') {
        if (_.isEmpty(this.$route.query)) {
          this.aiASMDashboard({
            router,
            query: {
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
        } else {
          this.aiASMDashboard({
            router,
            query: {
              startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
              enddate: moment(this.endDateValue).format('YYYY-MM-DD')
            }
          });
        }
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.aiASMDashboard({ query: to.query });
    next();
  },
  methods: {
    ...mapActions('asmList', ['asmListAction']),
    ...mapActions('dashboard', ['aiReport', 'aiASMReport', 'aiASMDashboard']),
    ...mapActions('store', ['listStore', 'listRegion']),
    ...mapActions('cstSubmission', ['getStoreByUser']),
    ...mapActions('user', ['list']),
    downloadASMReport() {
      this.aiASMReport({
        router,
        query: {
          startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
          enddate: moment(this.endDateValue).format('YYYY-MM-DD')
        }
      });
    },
    aiCalculations(newValue, imageType) {
      const updatedStatusRegionDetails = (newValue.all ?? [])
        .map((regionObj, index) => {
          const regionName = Object.keys(regionObj)[0];
          const regionData = regionObj[regionName];

          const count = regionData?.[imageType] ?? 0;
          const completion = regionData.total ? Math.round((count / regionData.total) * 100) : 0;

          return {
            id: index + 1,
            name: regionName,
            correct: regionData.correct,
            incorrect: regionData.incorrect,
            total: regionData.total,
            completion
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name));
      const updatedStatusRegionDetails2 = (newValue.all ?? [])
        .map((regionObj, index) => {
          const regionName = Object.keys(regionObj)[0];
          const regionData = regionObj[regionName];

          const count = regionData?.[imageType] ?? 0;
          const completion = regionData.total ? Math.round((count / regionData.total) * 100) : 0;

          const stores = Object.entries(regionData.stores || {}).map(([storeName, storeData]) => {
            const storeCount = storeData?.[imageType] ?? 0;
            const storeCompletion = storeData.total ? Math.round((storeCount / storeData.total) * 100) : 0;

            return {
              name: storeName,
              correct: storeData.correct,
              incorrect: storeData.incorrect,
              total: storeData.total,
              completion: storeCompletion
            };
          });

          return {
            id: index + 1,
            name: regionName,
            correct: regionData.correct,
            incorrect: regionData.incorrect,
            total: regionData.total,
            completion,
            stores
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name));

      // 2. Overall Completion
      const count = newValue?.[imageType] ?? 0;
      const overallCompletion = newValue.total ? Math.round((count / newValue.total) * 100) : 0;

      // 3. Date-wise Stats
      const flattenedByDate = (newValue.byDate ?? []).reduce((acc, item) => {
        const key = Object.keys(item)[0];
        acc[parseInt(key, 10)] = item[key];
        return acc;
      }, {});

      const statusByDate = Array.from({ length: 30 }, (_, i) => {
        const dayNumber = i + 1;
        const data = flattenedByDate[dayNumber];

        const count = data?.[imageType] ?? 0;
        const completion = data?.total ? Math.round((count / data.total) * 100) : 0;

        return {
          id: dayNumber,
          date: dayNumber,
          correct: data?.correct ?? 0,
          incorrect: data?.incorrect ?? 0,
          total: data?.total ?? 0,
          completion
        };
      });

      // 4. Checklist Breakdown
      const checklists = Object.entries(newValue.checklistsByRegion ?? {}).map(([checklistName, regionsData]) => {
        let totalCount = 0;
        let totalTotal = 0;

        const regions = Object.entries(regionsData).map(([regionName, data]) => {
          const { correct = 0, incorrect = 0, total = 0 } = data;
          const count = imageType === 'correct' ? correct : incorrect;

          totalCount += count;
          totalTotal += total;

          return {
            region: regionName,
            correct,
            incorrect,
            total,
            compliance: total ? Math.round((count / total) * 100) : 0
          };
        });

        return {
          appendText: 'status',
          checklist: checklistName,
          compliance: totalTotal ? Math.round((totalCount / totalTotal) * 100) : 0,
          regions
        };
      });

      // 5. Combine all results
      return {
        score: statusByDate,
        overallCompletion,
        checklists,
        heading: `AI Validation ${imageType === 'correct' ? 'Pass' : 'Fail'} %`,
        regionDetails: updatedStatusRegionDetails2
      };
    },
    showChart() {
      const startDate = moment(this.startDateValue);
      const endDate = moment(this.endDateValue);
      const difference = endDate.diff(startDate, 'days');
      if (difference >= 0 && difference <= 31) {
        const query = { ...this.$route.query };
        this.$router.push({
          query: {
            ...query,
            startdate: moment(this.startDateValue).format('YYYY-MM-DD'),
            enddate: moment(this.endDateValue).format('YYYY-MM-DD')
          }
        });
      } else {
        Vue.swal({
          title: 'Proceed Validation',
          text: `Days limit upto 30`,
          type: 'error',
          background: this.isDarkMode ? '#464d54' : '#ffffff',
          customClass: {
            title: this.isDarkMode ? 'text-light' : 'text-dark',
            content: this.isDarkMode ? 'text-light' : 'text-dark'
          }
        });
      }
    }
  },
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('auth', ['user']),
    ...mapState('cstSubmission', ['store', 'storeLoading']),
    ...mapState('asmList', ['asmList']),
    ...mapState('dashboard', [
      'loading',
      'reportAILoading',
      'dashboardData',
      'ticketData',
      'ticketLoading',
      'dashboardAiReport',
      'dashboardASMAiReport',
      'aSMReportLoading',
      'dashboardASMAiDashboard',
      'aSMDashboardLoading'
    ]),
    ...mapState('store', ['storeList', 'regionList']),
    ...mapState('user', ['users']),
    ...mapGetters('pettyCash', ['ifPettyCashTeam']),
    isAdmin() {
      return this.user.roles.some(role => role.name === 'ADMIN');
    },
    loginnedUserRegions() {
      return this.users.filter(i => i.mobile === this.user.mobile).map(item => item.regions);
    },
    totalStoreList() {
      return this.storeList
        .map(item => ({ text: `${item.storeName}-${item.storeid}`, value: item.storeid }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    loginnedUserStores() {
      return this.store
        .map(item => ({ text: `${item.storeName}-${item.storeid}`, value: item.storeid }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    renderedASMList() {
      return this.asmList
        .map(item => ({ text: item.value, value: item.key }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    primaryFilterOptions() {
      if (this.isRSM) {
        return [
          { text: 'select', value: 'select' },
          { text: 'ASM ', value: 'asm' },
          { text: 'Store', value: 'store' }
        ];
      }
      if (this.isASM || this.isSSM) {
        return [
          { text: 'select', value: 'select' },
          { text: 'Store', value: 'store' }
        ];
      }
      if (this.isAdmin || this.isSubAdmin || this.isCEO) {
        return [
          { text: 'select', value: 'select' },
          { text: 'India', value: 'india' },
          { text: 'Region', value: 'region' },
          { text: 'ASM', value: 'asm' },
          { text: 'Store', value: 'store' }
        ];
      }
      return [
        { text: 'select', value: 'select' },
        { text: 'Store', value: 'store' }
      ];
    }
  },
  watch: {
    dashboardASMAiReport(newValue) {
      if (!Array.isArray(newValue) || newValue.length === 0) return;

      const groupedASM = {};
      const groupedStores = {};

      // Group entries
      for (const item of newValue) {
        const asm = item.asmName?.trim() || 'Unknown';
        const checklist = item.checklist?.trim() || 'Unknown';
        const storeName = item.storeName?.trim() || 'Unknown Store';
        const storeId = item.storeId?.trim() || 'Unknown ID';
        const isCorrect = item.remarks?.trim().toLowerCase() === 'correct';

        // ASM group
        if (!groupedASM[asm]) groupedASM[asm] = {};
        if (!groupedASM[asm][checklist]) groupedASM[asm][checklist] = { Correct: 0, Incorrect: 0 };
        groupedASM[asm][checklist][isCorrect ? 'Correct' : 'Incorrect']++;

        // Store group
        const storeKey = `${storeName}__${storeId}`;
        if (!groupedStores[storeKey]) {
          groupedStores[storeKey] = { storeName, storeId, Correct: 0, Incorrect: 0 };
        }
        groupedStores[storeKey][isCorrect ? 'Correct' : 'Incorrect']++;
      }

      // Start CSV string
      let csv = '';

      // ============================
      // ASM Summary Section
      // ============================
      csv += `ASM Name,Checklist Name,Correct,Incorrect,Total Result\n`;

      for (const [asm, checklistMap] of Object.entries(groupedASM)) {
        let asmCorrect = 0;
        let asmIncorrect = 0;
        const checklistEntries = Object.entries(checklistMap);

        checklistEntries.forEach(([checklist, counts], index) => {
          const correct = counts.Correct || 0;
          const incorrect = counts.Incorrect || 0;
          const total = correct + incorrect;

          asmCorrect += correct;
          asmIncorrect += incorrect;

          // Show asm name only in the first line
          const asmDisplay = index === 0 ? asm : '';
          csv += `${asmDisplay},${checklist},${correct},${incorrect},${total}\n`;
        });

        // Final row with totals, no ASM or checklist name
        csv += `,,${asmCorrect},${asmIncorrect},${asmCorrect + asmIncorrect}\n\n`;
      }

      // Two blank lines before next section
      csv += `\n\n`;

      // ============================
      // Store Summary Section
      // ============================
      csv += `Store Name,Store ID,Correct,Incorrect,Total\n`;

      for (const store of Object.values(groupedStores)) {
        const { storeName, storeId, Correct, Incorrect } = store;
        const total = Correct + Incorrect;
        csv += `${storeName},${storeId},${Correct},${Incorrect},${total}\n`;
      }

      // Two blank lines before raw entries
      csv += `\n\n`;

      // ============================
      // Raw Entries Section
      // ============================
      csv += `Raw Entries:\n`;
      csv += `ASM Name,Checklist Name,Submitted Date,Store Name,Store ID,Question,Remark,Score,Image\n`;

      newValue.forEach(item => {
        csv += `${item.asmName},${item.checklist},${item.submittedDate},${item.storeName},${item.storeId},"${item.question}",${item.remarks},${item.score},${item.image?.[0]}\n`;
      });

      // Trigger download
      const anchor = document.createElement('a');
      anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      anchor.target = '_blank';
      anchor.download = 'ASM_Ai_Report.csv';
      anchor.click();
    },
    imageType(newValue) {
      const abc = this.aiCalculations(this.dashboardASMAiDashboard, newValue);
      this.aiReportStatus = {
        ...this.aiReportStatus,
        ...abc
      };
    },
    dashboardASMAiDashboard(newValue) {
      const imageType = this.imageType;

      // 1. Region-wise Summary
      const abc = this.aiCalculations(newValue, this.imageType);

      this.aiReportStatus = {
        ...this.aiReportStatus,
        ...abc
      };
    }
  }
};
</script>
